import "./AdsMidRollMarkers.css";
const CONTAINER_CLASS = "vjs-ad-markers";
/**
 * Barrette gialle sulla barra di avanzamento (come YouTube), una per ogni mid-roll del VOD non
 * ancora consumato. percents arriva da midRollMarkerPositions: posizioni 0-100 sulla durata.
 * Le metto in percentuale cosi' seguono la barra quando cambia dimensione (resize, fullscreen,
 * vista cinema) senza ricalcoli. A ogni chiamata riscrivo tutte le barrette: sono al massimo una
 * decina e cambiano solo quando arriva la durata o quando un punto si consuma.
 */
export function renderMidRollMarkers(player, percents) {
    // la SeekBar e' l'elemento .vjs-progress-holder dentro la control bar
    const seekBar = player
        .getChild?.("ControlBar")
        ?.getChild?.("ProgressControl")
        ?.getChild?.("SeekBar")
        ?.el?.() ?? null;
    if (!seekBar) {
        return;
    }
    let container = seekBar.querySelector("." + CONTAINER_CLASS);
    if (!container) {
        container = document.createElement("div");
        container.className = CONTAINER_CLASS;
        // sono solo decorative: i lettori di schermo non le devono leggere
        container.setAttribute("aria-hidden", "true");
        // in fondo alla SeekBar: cosi' stanno sopra la parte gia' vista ma sotto pallino e tooltip
        seekBar.appendChild(container);
    }
    container.replaceChildren(...percents.map((percent) => {
        const marker = document.createElement("div");
        marker.className = "vjs-ad-marker";
        marker.style.left = percent + "%";
        return marker;
    }));
}
